import axios from "axios";
import { _getByUrl } from "./service";
import { normalizeMetricOfferIds } from "../helpers/utils";
const { VITE_RIS_METRICA_URL, VITE_API_URL } = import.meta.env;

const instanceTracker = axios.create({
    baseURL: `https://${VITE_RIS_METRICA_URL}`,
    headers: {},
    withCredentials: true,
    responseType: "json",
});

let _refreshSessionPromise = false;

const mod = {};
mod._initTracker = async (data) => {
    if (!window.risMetrika) {
        window.risMetrika = {};
    }

    if (!window.localStorage.getItem("_uuid_rispromo")) {
        return null;
    }

    window.risMetrika = {
        ...window.risMetrika,
        ...data,
        reachgoal_ch: mod.reachgoal_ch,
        _pr_c_st: 0,
    };
};

let stop = false;
mod.reachgoal_ch = async (obj) => {
    if (window.risMetrika._pr_c_st === 1 || window.risMetrika._pr_c_st === 2) {
        return null;
    }

    const duplicate = window.risMetrika.getDuplicateOfferDetails?.(obj?.offerId);
    const isDuplicated = Boolean(duplicate) || (typeof window.risMetrika.isDuplicatedOffer === "function" && window.risMetrika.isDuplicatedOffer(obj?.offerId));
    const additionalProperty = obj?.additional_property;
    const trackerData = isDuplicated
        ? {
              ...obj,
              ...(duplicate?.position === undefined ? {} : { position: duplicate.position }),
              additional_property: {
                  ...(additionalProperty && typeof additionalProperty === "object" ? additionalProperty : {}),
                  isDuplicated: true,
              },
          }
        : obj;
    const normalizedObj = normalizeMetricOfferIds(trackerData);
    const dataConvert = {
        cda: bytesToBase64(JSON.stringify({ ...normalizedObj })),
    };
    console.log("REACHGOAL ch_goals-->", normalizedObj);

    try {
        const response = await instanceTracker.post(`/services/app/ch_goals`, JSON.stringify(dataConvert), {
            headers: {
                "Content-type": "application/json; charset=UTF-8",
                "req-counter": window.risMetrika.counter,
            },
        });

        if (response.data.isNotSession) {
            stop = false;
        }

        if (response && response.data && response.data.isNotSession) {
            if (stop) return;
            saveEventToStorage(dataConvert);

            if (!_refreshSessionPromise) {
                const resp = await getRefreshSessionPromise();

                if (resp && resp.success) {
                    _refreshSessionPromise = resp;

                    const arr = getStoredEvents();

                    console.log(arr, "getStoredEvents");

                    if (arr && arr.length) {
                        if (!response?.data?.isNotSession) return;
                        for (let i = 0; i < arr.length; i++) {
                            const item = arr[i];
                            const isLast = i === arr.length - 1;
                            try {
                                await sendEvent(item, "ch_goals");
                                _refreshSessionPromise = false;

                                if (isLast) {
                                    localStorage.removeItem("arr_event_metrika");
                                    _refreshSessionPromise = false;
                                    stop = true;
                                }
                            } catch (error) {
                                console.error("❌ Ошибка отправки элемента:", item.cda, error.message);
                            }
                        }
                    }
                }
            }
        }
        return true;
    } catch (e) {
        if (e && e.status === 401) {
            console.error("❌ Ошибка авторизации");
        }
    }
};

const bytesToBase64 = (str) => {
    const strIn = new TextEncoder().encode(str);

    const binString = Array.from(strIn, (byte) => String.fromCodePoint(byte)).join("");
    return btoa(binString);
};

const saveEventToStorage = (eventData) => {
    try {
        const stored = localStorage.getItem("arr_event_metrika");
        const events = stored ? JSON.parse(stored) : [];
        events.push(eventData);
        localStorage.setItem("arr_event_metrika", JSON.stringify(events));
        return true;
    } catch (e) {
        console.error("❌ Ошибка сохранения в localStorage:", e);
        return false;
    }
};

const getStoredEvents = () => {
    try {
        const stored = localStorage.getItem("arr_event_metrika");

        console.log(stored, "stored");

        if (!stored) return [];
        const events = JSON.parse(stored);
        return Array.isArray(events) ? events : [];
    } catch {
        return [];
    }
};

const sendEvent = async (eventData, url) => {
    try {
        const response = await instanceTracker.post(`/services/app/${url}`, JSON.stringify(eventData), {
            headers: {
                "Content-type": "application/json; charset=UTF-8",
                "req-counter": window.risMetrika.counter,
            },
        });
        return { success: true, response };
    } catch (error) {
        console.error("❌ Ошибка отправки:", eventData.cda, error.message);
        return { success: false, error };
    }
};

// Глобальная переменная для блокировки (вынесена на уровень модуля)

const getRefreshSessionPromise = () => {
    console.log(_refreshSessionPromise, "_refreshSessionPromise");

    // Если запрос уже выполняется — возвращаем тот же промис
    if (_refreshSessionPromise) {
        return _refreshSessionPromise;
    }

    // Создаём промис и СРАЗУ сохраняем ссылку на него (до любого await!)
    _refreshSessionPromise = (async () => {
        try {
            let resp = await _getByUrl("/app_rispromo_user/refresh_sessions");

            if (resp && resp.success) {
                _refreshSessionPromise = resp;
                return resp;
            }
        } finally {
            // Сбрасываем лок ТОЛЬКО после полного завершения (успех или ошибка)
            _refreshSessionPromise = false;
        }
    })();

    return _refreshSessionPromise;
};

export default mod;
